"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const App_1 = require("./components/App");
const version_1 = require("./version");
const client_1 = require("react-dom/client");
require("bootstrap/dist/css/bootstrap.min.css");
require("./css.scss");
const TICKS_PER_SECOND = 20;
const root = (0, client_1.createRoot)(document.getElementById("view"));
root.render((0, jsx_runtime_1.jsx)(App_1.App, { ticksPerSecond: TICKS_PER_SECOND }));
document.title = "idlefactorygame v" + (0, version_1.VERSION)().join(".");
